import { render, staticRenderFns } from "./LegalSection.vue?vue&type=template&id=27b76ac8&scoped=true"
import script from "./LegalSection.vue?vue&type=script&lang=js"
export * from "./LegalSection.vue?vue&type=script&lang=js"
import style0 from "./LegalSection.vue?vue&type=style&index=0&id=27b76ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b76ac8",
  null
  
)

export default component.exports